import Instance from "../../../../Axios";

// New Actions for the app

const GetCredHabilitacoes = () => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/habilitacoes`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_HABILITACOES",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredHabilitacoes;